import {AxiosWrapper} from "../../shared/utils/axios.wrapper";

export class CbFiltersService {
  static async fetchAllFilters(): Promise<any[]> {
    const response = await AxiosWrapper.get(`/api/CompetitiveBidding/GetFilters`);
    return response.data.filter(el=>el.key!=='ApproverEmailAddresses') as any[];
  }
}
